import type { ArtManifest, Story, UiContent } from "./types";
import { validateStory, validateUi } from "./validate";

async function readJson(url: string): Promise<unknown> {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`${url}: HTTP ${response.status}`);
  return response.json();
}

export async function loadGameData(): Promise<{
  story: Story;
  ui: UiContent;
  art: ArtManifest;
}> {
  const [story, ui, art] = await Promise.all([
    readJson("./content/story.json"),
    readJson("./content/ui.json"),
    readJson("./art/manifest.json"),
  ]);
  return {
    story: validateStory(story),
    ui: validateUi(ui),
    art: art as ArtManifest,
  };
}
